/*
 * Finds "Cozyzzz", "CozyThrowzzz", and "CozyCozzz" (with an optional trailing
 * ™) anywhere in the rendered page text and wraps the "zzz" and "™" in
 * <sup> spans (see .brand-zzz / .brand-tm in base.css) so the brand mark
 * renders consistently without every section/template needing its own markup.
 * Runs once on load, then re-runs on any DOM subtree Shopify/theme JS injects
 * later (cart drawer, quick add, section reloads, etc.).
 */
(function () {
  var WORD_RE = /(Cozyzzz|CozyThrowzzz|CozyCozzz)(™)?/g;
  var SKIP_TAGS = { SCRIPT: 1, STYLE: 1, TEXTAREA: 1, INPUT: 1, SELECT: 1, NOSCRIPT: 1, TITLE: 1 };

  function escapeHTML(str) {
    return str.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
  }

  function buildReplacementHTML(word, tm) {
    var zzz = word.slice(-3);
    var head = word.slice(0, word.length - 3);
    var html = '<span class="brand-name">' + head + '<sup class="brand-zzz">' + zzz + '</sup>';
    if (tm) html += '<sup class="brand-tm">' + tm + '</sup>';
    html += '</span>';
    return html;
  }

  function processTextNode(node) {
    var text = node.nodeValue;
    WORD_RE.lastIndex = 0;
    if (!WORD_RE.test(text)) return;
    WORD_RE.lastIndex = 0;

    // Build one HTML string and swap the text node for a single wrapping
    // <span>, rather than a multi-node fragment. Some parents (e.g. buttons,
    // which use display:grid to center their label) generate a separate
    // anonymous grid/flex item per direct child, so replacing one text node
    // with several sibling nodes can force each into its own row/column.
    // A single wrapper element keeps the child count unchanged.
    var html = '';
    var lastIndex = 0;
    var match;
    while ((match = WORD_RE.exec(text))) {
      if (match.index > lastIndex) {
        html += escapeHTML(text.slice(lastIndex, match.index));
      }
      html += buildReplacementHTML(match[1], match[2]);
      lastIndex = WORD_RE.lastIndex;
    }
    if (lastIndex < text.length) {
      html += escapeHTML(text.slice(lastIndex));
    }

    var wrapper = document.createElement('span');
    wrapper.className = 'brand-mark-wrap';
    wrapper.innerHTML = html;
    if (node.parentNode) node.parentNode.replaceChild(wrapper, node);
  }

  function isInsideBrandMark(el) {
    return !!(el.closest && el.closest('.brand-mark-wrap, .brand-name, .brand-zzz, .brand-tm'));
  }

  function walk(root) {
    if (root.nodeType === 3) {
      if (root.parentNode && !isInsideBrandMark(root.parentNode)) processTextNode(root);
      return;
    }
    if (root.nodeType !== 1 || SKIP_TAGS[root.tagName] || isInsideBrandMark(root)) return;

    var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, {
      acceptNode: function (n) {
        var p = n.parentNode;
        if (!p || SKIP_TAGS[p.tagName] || isInsideBrandMark(p)) return NodeFilter.FILTER_REJECT;
        WORD_RE.lastIndex = 0;
        return WORD_RE.test(n.nodeValue) ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
      },
    });

    var nodes = [];
    var n;
    while ((n = walker.nextNode())) nodes.push(n);
    nodes.forEach(processTextNode);
  }

  function run() {
    walk(document.body);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }

  if (window.MutationObserver) {
    var observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        mutation.addedNodes.forEach(function (node) {
          walk(node);
        });
      });
    });
    document.addEventListener('DOMContentLoaded', function () {
      observer.observe(document.body, { childList: true, subtree: true });
    });
    if (document.readyState !== 'loading') {
      observer.observe(document.body, { childList: true, subtree: true });
    }
  }
})();
